import "./Business.scss";
import { Content } from "antd/es/layout/layout";
import { theme } from "antd";
import { RocketOutlined } from "@ant-design/icons";
import { ContactUs, HeroCard } from "../../components";
import { BusinessServices, PricingCard } from "./components";

export default function Business() {
  const { useToken } = theme;
  const { token } = useToken();

  const heroData = {
    icon: <RocketOutlined style={{ color: "#fff", fontSize: 40 }} />,
    title: "Empower Your Business",
    description:
      "Transform healthcare management with our comprehensive platform designed for organizations that demand excellence, security, and scalability.",
  };

  return (
    <Content className="business-cont">
      {/* Hero Section */}
      <HeroCard token={token} {...heroData} />

      {/* Main Content Section */}
      <div className="business-cont__mainContent">
        <BusinessServices token={token} />
        <PricingCard token={token} />
      </div>

      <ContactUs token={token} />
    </Content>
  );
}
